<template>
  <el-form
    label-width="100px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <p style="padding-left: 100px;width: 100%;text-align: left;">格式样例：快递公司，快递号，订单ID【一个订单一行】</p>
    <p style="padding-left: 100px;width: 100%;text-align: left;">顺丰,sf3224234,orderid342342</p>
    <p style="padding-left: 100px;width: 100%;text-align: left;">顺丰,sf3224234,orderid342342</p>
    <el-form-item label="文本" required>
      <el-input v-model="form.text" rows="10" style="width: 100%;" type="textarea" />
    </el-form-item>

  </el-form>
</template>

<script setup>
import { ref } from "vue";

const form = ref({
  text: "",
});



defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

::v-deep .el-form-item {
  width: 100%;
}
</style>
